import React from "react";
import useLocales from "../../../hooks/useLocales";
import { ReactComponent as CheckIcon } from "../../../assets/checkicon.svg";

const ReportAbuseConfirm = ({ isOpen, onCancel, onConfirm }) => {
  const { translate } = useLocales();
  if (!isOpen) return null;
  return (
    <div
      style={{ zIndex: "999999999999" }}
      className="fixed inset-0 h-screen w-screen flex items-center justify-center"
    >
      <div
        style={{ zIndex: "999999" }}
        className="absolute h-screen w-screen inset-0 bg-gray-800 opacity-50"
      ></div>
      <div
        className="flex items-center justify-center h-[380px] sm:h-[416px]"
        style={{ zIndex: "999999" }}
      >
        <div className="bg-white p-10 text-center dark:bg-dark-secondary shadow-lg rounded-[20px] w-[327px] sm:w-[570px]">
          <div className="mb-4">
            <CheckIcon className="mx-auto h-[100px] w-[100px] sm:h-[120px] sm:w-[120px]" />
          </div>
          <h6 className="sm:text-custom_h6r text-body_copy2 mb-2 text-heading_color dark:text-color_v1_dark">
            {translate("report.your_submission_received")}
          </h6>
          <p className="sm:text-body_copy2 text-small1 text-font_light_color mb-6 dark:text-font_light_color">
            {translate("report.you_will_contacted")}
          </p>
          <button
            onClick={onCancel}
            className="text-white rounded-full px-[26px] pb-2 pt-[9px] sm:px-10 sm:py-3 bg-main_color text-small2_b sm:text-small1_bold sm:h-12 sm:w-48 h-[37px] w-[119px]"
          >
            {translate("report.go_home")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportAbuseConfirm;
